import { useEffect } from "react"
import PropTypes from "prop-types"

import { verifyIntendedPromiseRejection } from "./utils/modal_promise"

import "./diy_add_tanda_button.scss"
import { attachNewBadgeForButtons } from "shared/scripts/new_badge_button.tsx"
import PlusIcon from "shared/components/icons/plus_icon"
import proPlusBadge from "images/plan-badges/pro_plus.svg"

export default function DIYAddFilterQueryButtons({
  delayAdded,
  filterCodeAdded,
  onDelayButtonClick,
  onFilterButtonClick,
  onQueryButtonClick,
  userTier,
}) {
  useEffect(() => {
    attachNewBadgeForButtons()
  }, [])

  return (
    <section styleName="add-new-query-filter-delay">
      <div
        styleName="add-query"
        onClick={verifyIntendedPromiseRejection(onQueryButtonClick)}
      >
        <div className="description">
          <div styleName="title">
            <h4 className="h4">Query</h4>
            {userTier != "pro" && (
              <span
                styleName="badge pro_plus"
                dangerouslySetInnerHTML={{ __html: proPlusBadge }}
              />
            )}
            <span styleName="badge" data-allow-new-badge="queries" />
          </div>
          <p className="txt-body-3">Get additional data from triggers</p>
        </div>
        <button className="plus-icon-button" styleName="add">
          <PlusIcon />
        </button>
      </div>
      {filterCodeAdded ? (
        <></>
      ) : (
        <div
          styleName="add-filter"
          onClick={verifyIntendedPromiseRejection(onFilterButtonClick)}
        >
          <div className="description">
            <div styleName="title">
              <h4 className="h4">Filter code</h4>
              {userTier != "pro" && (
                <span
                  styleName="badge pro_plus"
                  dangerouslySetInnerHTML={{ __html: proPlusBadge }}
                />
              )}
              <span styleName="badge" data-allow-new-badge="filter_code" />
            </div>
            <p className="txt-body-3">Add the power of JavaScript logic</p>
          </div>
          <button className="plus-icon-button" styleName="add">
            <PlusIcon />
          </button>
        </div>
      )}
      {delayAdded ? (
        <></>
      ) : (
        <>
          <div
            styleName="add-delay"
            onClick={verifyIntendedPromiseRejection(onDelayButtonClick)}
          >
            <div className="description">
              <div styleName="title">
                <h4 className="h4">Delay</h4>
                <span styleName="badge" data-allow-new-badge="delay" />
              </div>
              <p className="txt-body-3">Add a delay to the next action</p>
            </div>
            <button className="plus-icon-button" styleName="add">
              <PlusIcon />
            </button>
          </div>
        </>
      )}
    </section>
  )
}

DIYAddFilterQueryButtons.propTypes = {
  delayAdded: PropTypes.bool,
  filterCodeAdded: PropTypes.bool,
  onDelayButtonClick: PropTypes.func.isRequired,
  onFilterButtonClick: PropTypes.func.isRequired,
  onQueryButtonClick: PropTypes.func.isRequired,
  userTier: PropTypes.string.isRequired,
}
